import Image from "next/image"

export function Picture({ imgClassName, alt, defaultSrc, className, webpSrc, loading = "lazy", height, width }) {
    return (
        <picture className={className}>
            {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
            <Image src={defaultSrc} alt={alt} className={imgClassName} loading={loading} width={width} height={height} />
        </picture>
    )
}
